import { combine, withState, withCallbacks } from 'react-hooks-combine'

import EditablePanelComponent from './component'

export const EditableFormPanel = combine(
  withState('editable', 'edit', false),
  withCallbacks({
    onEdit:
      ({ edit }) =>
      () => {
        edit(true)
      },

    onSave:
      ({ edit }, { onSubmit, resetAfterSubmit, form }) =>
      (formValues) => {
        edit(false)

        if (resetAfterSubmit) {
          form.reset()
        }

        return onSubmit(formValues)
      },

    onCancel:
      ({ edit }, { form }) =>
      () => {
        form.reset()
        edit(false)
      },
  })
)(EditablePanelComponent)
